import { withStyles } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { ERebrandingColors, ERebrandingFonts } from 'helpers/constants';

export const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: ERebrandingFonts.OPENSANS,
  },
  tag: {
    padding: '5px 10px',
    borderRadius: '4px',
    fontSize: '.75rem',
    textTransform: 'uppercase',
    color: ERebrandingColors.MAIN,
    backgroundColor: theme.palette.grey[200],
  },
  smallInfo: {
    fontSize: '0.625rem',
    paddingRight: '10px',
  },
  buttonsMobile: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      margin: '0 8px 28px',
    },
  },
  buttonsContainer: {
    alignSelf: 'center',
    marginLeft: 'auto',
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  button: {
    textTransform: 'none',
    fontWeight: 600,
    fontFamily: 'inherit',
  },
  btnIcon: {
    marginRight: 8,
    padding: 0,
    minWidth: 40,
    '&:disabled': {
      opacity: '.3',
    },
  },
  imgIcon: {
    width: 20,
    height: 20,
  },
  oldStatementButton: {
    color: ERebrandingColors.MAIN,
    borderColor: ERebrandingColors.LIGHT,
    marginRight: '0.75rem',
  },
}));

export const CustomTabs = withStyles((theme) => ({
  root: {
    marginTop: 20,
    marginBottom: 24,
    fontWeight: 600,
    borderBottom: `1px solid ${theme.palette.grey[400]}`,
  },
  indicator: {
    backgroundColor: ERebrandingColors.MAIN,
  },
}))(Tabs);

export const CustomTab = withStyles(() => ({
  root: {
    minWidth: 'unset',
    textTransform: 'none',
  },
  selected: {
    color: ERebrandingColors.MAIN,
  },
}))(Tab);
